import { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { MenuConfig, ThemeConfig } from '#/service/config/config.types';

import { SplashBg } from './Splash.styled';

interface SplashProps {
  /** The menu data */
  menu: MenuConfig;
  /** Theme. Only used in tests. Runtime it is coming from context. */
  theme?: ThemeConfig;
  /** Start fading out when this turns true. */
  startFadeout?: boolean;
}

/** Splash screen component */
export const Splash: FC<SplashProps> = ({
  menu,
  theme,
  startFadeout = false,
}) => {
  const { color: { pageBackground = 'black' } = {} } =
    useContext(ThemeContext) || theme || {};
  // make a copy of the menu without the menu items

  if (!menu) {
    return null;
  }

  return (
    <SplashBg
      $backgroundColor={pageBackground}
      $startFadeout={startFadeout}
      data-testid="splash-background"
      key="splash-bg"
    />
  );
};
